var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveRuleChanges(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5.5C12.5 4.67872 12.4691 3.86466 12.4083 3.05893C12.3085 1.73616 11.2638 0.691494 9.94107 0.591716C9.13534 0.530939 8.32128 0.5 7.5 0.5C6.67872 0.5 5.86466 0.530939 5.05893 0.591716C3.73617 0.691494 2.69149 1.73616 2.59172 3.05893C2.58065 3.20568 2.57057 3.35271 2.56148 3.5M12.5 5.5L14.5 3.5M12.5 5.5L10.5 3.5M2.5 5.5C2.5 6.32128 2.53094 7.13534 2.59172 7.94107C2.69149 9.26383 3.73617 10.3085 5.05893 10.4083C5.86466 10.4691 6.67872 10.5 7.5 10.5C8.32128 10.5 9.13534 10.4691 9.94107 10.4083C11.2638 10.3085 12.3085 9.26383 12.4083 7.94107C12.4194 7.79432 12.4294 7.64729 12.4385 7.5M2.5 5.5L4.5 7.5M2.5 5.5L0.5 7.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveRuleChanges);
export default __webpack_public_path__ + "static/media/active-rule-changes.b038d226d167693009c2eb1b9b7198fa.svg";
export { ForwardRef as ReactComponent };